export const type = {
  feeTypes: {
    initial: 'INITIAL',
    recurring: 'RECURRING',
    commission: 'COMMISSION',
    fee: 'ONE OFF FEE',
    discount: 'ONE OFF DISCOUNT',
    adviser: 'ADVISER',
    performance: 'PERFORMANCE',
  },
  feeCalculationBasis: {
    fixed: 'FIXED',
    percentage: 'PERCENTAGE',
  },
  feeAccounting: {
    chargedToInvestor: 'CHARGED_TO_INVESTOR',
    accrued: 'ACCRUED',
  },
  feeHurdleBasis: {
    company: 'COMPANY',
    investment: 'INVESTMENT',
  },
};
